import * as d3 from "d3";
import {showLabel} from "../RadarChart.functions";
import {SidebarTab} from "../../Sidebar";
import {ITypeRadar} from "../../../types";
import {fetchTechnologyData} from "../../../helper";
import {xScale} from "../../../mocks/projectsMock";

interface ClusterPointProps {
  cluster: any;
  xStart: number;
  yStart: number;
  xMoleculaTwo: number;
  yMoleculaTwo: number;
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>;
  segmentColor: {back: string; color: string};
  innerColor: {back: string; color: string};
  isActiveCluster: boolean;
  showAllLabels: boolean;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar,
    isSearchPanelActive?: boolean,
    clusterIdNumber?: number,
    idRndIndex?: number
  ) => void;
  typeRadar: ITypeRadar;
  sectionName: string;
  setFocusPosition: (position: {x: number; y: number}) => void;
  isWeak_signal?: boolean;
  scale: number;
  hideLabel: () => void;
  activeTehnologyIdTwo: number | string | null | undefined;
  index: number;
  rayAngle?: number;
}

const renderClusterPointMoleculeTwo = ({
  cluster,
  xStart,
  yStart,
  xMoleculaTwo,
  yMoleculaTwo,
  mainGroup,
  segmentColor,
  innerColor,
  isActiveCluster,
  showAllLabels,
  openSidebarWithTab,
  typeRadar,
  sectionName,
  setFocusPosition,
  isWeak_signal,
  scale,
  hideLabel,
  activeTehnologyIdTwo: activeTehnologyId,
  index,
  rayAngle: rayAngleLabel,
}: ClusterPointProps) => {
  const hexagonPoints = (cx: number, cy: number, radius: number) => {
    const points = [];
    for (let j = 0; j < 6; j++) {
      const angle = (Math.PI / 3) * j;
      const x = cx + radius * Math.cos(angle);
      const y = cy + radius * Math.sin(angle);
      points.push(`${x},${y}`);
    }
    return points.join(" ");
  };

  // let angleOffset = 0;
  // let rayAngle = segmentCenterAngle;
  // if (count > 1) {
  //   if (typeRadar === "moleculeTwo") {
  //     const availableAngleNew = 360;
  //     const angleBetweenRays = availableAngleNew / count;
  //     angleOffset = -availableAngleNew / 2 + (index + 0.5) * angleBetweenRays;
  //   }
  //   // rayAngle = segmentCenterAngle + angleOffset;
  // }

  const clusterPoint = mainGroup.append("g");
  const hoverColor = segmentColor;
  const deltaSizeDotOuter = typeRadar === "molecula" ? 10 : 2;

  const circleRadius = Math.min(
    Math.max(4, cluster.size * deltaSizeDotOuter),
    8
  );

  let typeOpenCard: SidebarTab;
  switch (typeRadar) {
    case "map":
      typeOpenCard = SidebarTab.CPU;
      break;
    case "moleculeTwo":
      typeOpenCard = SidebarTab.Projects;
      break;
    case "esg":
      typeOpenCard = SidebarTab.Projects;
      break;
    case "fintech":
      if (!isWeak_signal) {
        typeOpenCard = SidebarTab.Trends;
      } else {
        typeOpenCard = SidebarTab.WeakSignal;
      }
      break;
    case "stateInitiative":
      typeOpenCard = SidebarTab.StateInitiative;
      break;
    default:
      typeOpenCard = SidebarTab.CPU;
  }

  const line = () =>
    clusterPoint
      .append("line")
      .attr("x1", xMoleculaTwo)
      .attr("y1", yMoleculaTwo)
      .attr("x2", xStart)
      .attr("y2", yStart)
      .attr("stroke", "white")
      .attr("opacity", 1)
      .attr("stroke-width", 1);

  // line();
  const fontSizeMolecule = 8;
  const numCircles = 2;
  const radius = 40;
  const angle2 = Math.atan2(yStart, xStart);
  if (cluster.tehnologies !== undefined && cluster.tehnologies.length > 0) {
    const cutTehnologies = cluster.tehnologies.slice(0, 5);
    for (let i = 0; i < cutTehnologies.length; i++) {
      const angle = (i * 2 * Math.PI) / 4 / numCircles;
      let numAngle: number = (cutTehnologies.length - 1) * 0.4;
      const xN = xStart + radius * Math.cos(angle + angle2 - numAngle);
      const yN = yStart + radius * Math.sin(angle + angle2 - numAngle);

      const techData = async (techIndex: number, circleIndex: number) => {
        let isActiveSomeTechnologie = false;
        const nameTech = {
          name: cluster.tehnologies?.[techIndex].name,
        };

        const hideLabelTechnology = (
          isActiveTehnology = false,
          id?: string,
          activeTehnologyId?: number | string
        ) => {
          if (isActiveTehnology) return;
          mainGroup.selectAll(`.tooltip-background-technology${id}`).remove();
          mainGroup.selectAll(`.tooltip-text-technology${id}`).remove();
        };

        const isActiveTehnology =
          `${activeTehnologyId}` ===
          `${cutTehnologies?.[techIndex].documentId}-${index}`;

        if (isActiveTehnology) {
          isActiveSomeTechnologie = true;
        }

        clusterPoint
          .append("line")
          .attr("x1", xStart)
          .attr("y1", yStart)
          .attr("x2", xN)
          .attr("y2", yN)
          .attr("stroke", "white")
          .attr("stroke-width", 0.5);
        clusterPoint
          .append("polygon")
          .attr("id", `outcircle-${cluster.id}-${techIndex}`)
          .attr("points", hexagonPoints(xN, yN, 8))
          .style("fill", "#2196F3")
          .style("stroke", "white")
          .style("stroke-width", "1px")
          .style("cursor", "pointer")
          .on("mouseover", function (d) {
            d3.select(this.parentElement)
              .select(`#outline-inner-circle-${cluster.id}`)
              .style("opacity", 0);
            if (isActiveTehnology) return;
            hideLabelTechnology(
              isActiveTehnology,
              `${cluster?.tehnologies?.[techIndex].documentId}${circleIndex}`,
              activeTehnologyId ?? undefined
            );
            showLabel(
              cluster.tehnologies?.[techIndex].documentId
                ? String(nameTech?.name)
                : "",
              xN,
              yN,
              mainGroup,
              `${cluster?.tehnologies?.[techIndex].documentId}${circleIndex}`,
              "technology",
              innerColor,
              showAllLabels,
              typeRadar,
              undefined,
              fontSizeMolecule,
              true,
              false,
              false,
              undefined,
              undefined
            );
          })
          .on("click", () => {
            openSidebarWithTab(
              SidebarTab.CPU,
              cluster.direction_id,
              cluster.id,
              cluster.name,
              sectionName,
              innerColor,
              cluster.tehnologies?.[techIndex].documentId
                ? String(nameTech?.name)
                : "",
              cluster.tehnologies?.[techIndex].documentId
                ? String(cluster.tehnologies[techIndex].documentId)
                : 0,
              "moleculeTwo",
              undefined,
              undefined,
              index
            );
            if (xN && yN) setFocusPosition({x: xN, y: yN});
          })
          .on("mouseout", function () {
            // if (showAllLabels) return;
            hideLabelTechnology(
              isActiveTehnology,
              `${cluster?.tehnologies?.[techIndex].documentId}${circleIndex}`,
              activeTehnologyId ?? undefined
            );
            if (showAllLabels) {
              showLabel(
                String(nameTech?.name),
                xN,
                yN,
                mainGroup,
                `${cluster?.tehnologies?.[techIndex].documentId}${circleIndex}`,
                "technology",
                innerColor,
                showAllLabels,
                typeRadar,
                scale,
                fontSizeMolecule,
                false,
                true,
                false,
                undefined,
                undefined
              );
            }
          });

        if (showAllLabels && !isActiveTehnology) {
          showLabel(
            String(nameTech?.name),
            xN,
            yN,
            mainGroup,
            `${cluster?.tehnologies?.[techIndex].documentId}${circleIndex}`,
            "technology",
            innerColor,
            showAllLabels,
            typeRadar,
            scale,
            fontSizeMolecule,
            false,
            true,
            false,
            undefined,
            undefined
          );
        }
        if (isActiveTehnology) {
          showLabel(
            String(nameTech?.name),
            xN,
            yN,
            mainGroup,
            `${cluster?.tehnologies?.[techIndex].documentId}${circleIndex}`,
            "technology",
            innerColor,
            showAllLabels,
            typeRadar,
            scale,
            fontSizeMolecule,
            true,
            true,
            false,
            undefined,
            undefined
          );
        }
      };
      techData(i, Math.round(xN));
    }
  }
  clusterPoint
    .append("circle")
    .attr("cx", xStart)
    .attr("id", `outline-circle-${cluster.id}`)
    .attr("cy", yStart)
    .attr("r", circleRadius * 3)
    .style("fill", segmentColor.back)
    .attr("opacity", 0.5)
    .style("stroke", "none")
    .on("mouseover", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 1);
    })
    .on("mouseout", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 0);
    });

  clusterPoint
    .append("circle")
    .attr("id", `outline-inner-circle-${cluster.id}`)
    .attr("cx", xStart)
    .attr("cy", yStart)
    .attr("r", 6)
    .style("fill", "#fff")
    .style("stroke", "none")
    .style("opacity", 0)
    .on("mouseover", function () {
      d3.select(this).style("opacity", 1);
      d3.select(this.parentElement)
        .select(`#outline-circle-${cluster.id}`)
        .style("fill", hoverColor.back);
    })
    .on("mouseenter", function () {
      d3.select(this).style("border-radius", "1px");

      if (!showAllLabels) {
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo,
          rayAngleLabel
        );
      }
      if (showAllLabels) {
        mainGroup
          .select(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);

        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo,
          rayAngleLabel
        );
      }
    })
    .on("mouseleave", function () {
      // if (isActiveCluster) return;
      if (!showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id,
          activeTehnologyId ?? undefined
        );
      }
      if (showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id,
          activeTehnologyId ?? undefined
        );
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true
        );
      }
    })
    .on("mouseout", function () {
      d3.select(this).style("opacity", 0);
    });
  clusterPoint
    .append("circle")
    .attr("id", `inline-circle-${cluster.id}`)
    .attr("cx", xStart)
    .attr("cy", yStart)
    .attr("r", circleRadius * 3)
    .style("fill", "#86D1F2")
    .style("stroke", "white")
    .style("stroke-width", "1px")
    // .style("stroke-width", 0.5)
    .style("cursor", "pointer")
    .on("mouseover", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 1);

      if (isActiveCluster && !activeTehnologyId) return;
      hideLabelCluster(
        isActiveCluster,
        cluster.id,
        activeTehnologyId ?? undefined
      );
      if (!showAllLabels) {
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo,
          rayAngleLabel
        );
      }
      if (showAllLabels) {
        mainGroup
          .select(`.tooltip-background-cluster${cluster.id}`)
          .attr("opacity", 0);

        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          true,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo,
          rayAngleLabel
        );
      }
    })
    .on("mouseout", function () {
      d3.select(this.parentElement)
        .select(`#outline-inner-circle-${cluster.id}`)
        .style("opacity", 0);

      if (isActiveCluster && activeTehnologyId === "undefined-0") return;
      if (!showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id,
          activeTehnologyId ?? undefined
        );
      }
      if (showAllLabels) {
        hideLabelCluster(
          isActiveCluster,
          cluster.id,
          activeTehnologyId ?? undefined
        );
        showLabel(
          cluster.name,
          xStart,
          yStart,
          mainGroup,
          cluster.id,
          "cluster",
          innerColor,
          showAllLabels,
          typeRadar,
          scale,
          undefined,
          false,
          false,
          true,
          xMoleculaTwo,
          yMoleculaTwo,
          rayAngleLabel
        );
      }
    })
    .on("click", () => {
      openSidebarWithTab(
        typeOpenCard,
        cluster.direction_id,
        cluster.id,
        cluster.name,
        sectionName,
        innerColor,
        undefined,
        undefined,
        typeRadar
      );
      if (xStart && yStart) setFocusPosition({x: xStart, y: yStart});
    });
  // .on("mouseleave", function () {
  //   // if (isActiveCluster) return;

  // });

  const hideLabelCluster = (
    isActiveCluster = false,
    id: number,
    activeTehnologyId?: number | string
  ) => {
    if (isActiveCluster && !activeTehnologyId) return;
    mainGroup.selectAll(`.tooltip-background-cluster${id}`).remove();
    mainGroup.selectAll(`.tooltip-text-cluster${id}`).remove();
  };

  if (showAllLabels && !isActiveCluster) {
    showLabel(
      cluster.name,
      xStart,
      yStart,
      mainGroup,
      cluster.id,
      "cluster",
      innerColor,
      showAllLabels,
      typeRadar,
      scale,
      undefined,
      false,
      false,
      true,
      xMoleculaTwo,
      yMoleculaTwo,
      rayAngleLabel
    );
  }

  if (isActiveCluster) {
    showLabel(
      cluster.name,
      xStart,
      yStart,
      mainGroup,
      cluster.id,
      "cluster",
      innerColor,
      showAllLabels,
      typeRadar,
      scale,
      undefined,
      activeTehnologyId === "undefined-0" ? true : false,
      false,
      true,
      xMoleculaTwo,
      yMoleculaTwo,
      rayAngleLabel
    );
  }

  return null;
};

export default renderClusterPointMoleculeTwo;
